// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unlinked-dynamic-label::after {
  content: "Unlinked";
}

.unlinked-dynamic-label:hover::after {
  content: "Link to Portal";
}

.grid-3-cols {
  display: inline-grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

@media (max-width: 1100px) {
  .grid-3-cols {
    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}

@media (max-width: 920px) {
  .grid-3-cols {
    display: inline-grid;
    grid-template-columns: 1fr;
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvbWFpbi1kZXRhaWxzLWNhcmQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLG1CQUFtQjtBQUNyQjs7QUFFQTtFQUNFLHlCQUF5QjtBQUMzQjs7QUFFQTtFQUNFLG9CQUFvQjtFQUNwQixrQ0FBa0M7RUFDbEMsU0FBUztBQUNYOztBQUVBO0VBQ0U7SUFDRSxvQkFBb0I7SUFDcEIsOEJBQThCO0lBQzlCLFNBQVM7RUFDWDtBQUNGOztBQUVBO0VBQ0U7SUFDRSxvQkFBb0I7SUFDcEIsMEJBQTBCO0VBQzVCO0FBQ0YiLCJmaWxlIjoiZG9tYWluLWRldGFpbHMtY2FyZC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnVubGlua2VkLWR5bmFtaWMtbGFiZWw6OmFmdGVyIHtcbiAgY29udGVudDogXCJVbmxpbmtlZFwiO1xufVxuXG4udW5saW5rZWQtZHluYW1pYy1sYWJlbDpob3Zlcjo6YWZ0ZXIge1xuICBjb250ZW50OiBcIkxpbmsgdG8gUG9ydGFsXCI7XG59XG5cbi5ncmlkLTMtY29scyB7XG4gIGRpc3BsYXk6IGlubGluZS1ncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmciAxZnIgMWZyO1xuICBnYXA6IDIwcHg7XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiAxMTAwcHgpIHtcbiAgLmdyaWQtMy1jb2xzIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmciAxZnI7XG4gICAgZ2FwOiAyMHB4O1xuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA5MjBweCkge1xuICAuZ3JpZC0zLWNvbHMge1xuICAgIGRpc3BsYXk6IGlubGluZS1ncmlkO1xuICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyO1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/domains/domain-item/domain-details-card/domain-details-card.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;AACF;;AAEA,wpCAAwpC","sourcesContent":[".unlinked-dynamic-label::after {\n  content: \"Unlinked\";\n}\n\n.unlinked-dynamic-label:hover::after {\n  content: \"Link to Portal\";\n}\n\n.grid-3-cols {\n  display: inline-grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 1100px) {\n  .grid-3-cols {\n    display: inline-grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 920px) {\n  .grid-3-cols {\n    display: inline-grid;\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
